import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=3a1f1c9d"
import script from "./Notifications.vue?vue&type=script&lang=js"
export * from "./Notifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/websites/streamlined-business-solutions/sbs-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a1f1c9d')) {
      api.createRecord('3a1f1c9d', component.options)
    } else {
      api.reload('3a1f1c9d', component.options)
    }
    module.hot.accept("./Notifications.vue?vue&type=template&id=3a1f1c9d", function () {
      api.rerender('3a1f1c9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/messaging/Notifications.vue"
export default component.exports